import { DashboardStageOverviewCountdown } from './Countdown';
import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from '@tuic/tailwind-config';
import { Button, ButtonProps, Skeleton } from '../../../../core-components';
type DashboardStageOverviewImageProps = {
  fallback?: boolean;
  countdown: ComponentPropsWithoutRef<typeof DashboardStageOverviewCountdown> | undefined;
  mainImage?: React.ReactNode;
  highlightImage?: React.ReactNode;
  buttonHighlight?: ButtonProps;
  buttonItinerary?: ButtonProps;
};
export const DashboardStageOverviewImage: FC<DashboardStageOverviewImageProps> = ({
  fallback,
  countdown,
  mainImage,
  highlightImage,
  buttonHighlight,
  buttonItinerary
}) => {
  return <div className={twMerge('flex gap-6', countdown ? 'aspect-16/9 md:aspect-32/9' : 'aspect-32/9')} data-sentry-component="DashboardStageOverviewImage" data-sentry-source-file="Image.tsx">
      <div className="relative grow">
        {fallback && <Skeleton className="size-full rounded-sm" />}

        {!fallback && mainImage}

        {countdown && <div className="absolute inset-0 flex justify-center items-center">
            <DashboardStageOverviewCountdown {...countdown} />
          </div>}
        {!!buttonItinerary && <div className="hidden lg:block absolute bottom-4 right-4">
            <Button {...buttonItinerary} on="image" />
          </div>}
      </div>
      {!!highlightImage && <div className="hidden lg:block relative h-full">
          {fallback ? <Skeleton className="aspect-1/1 h-full rounded-sm" /> : highlightImage}
          {!!buttonHighlight && <div className="absolute bottom-4 right-4">
              <Button {...buttonHighlight} on="image" />
            </div>}
        </div>}
    </div>;
};